export default __webpack_public_path__ + "static/media/Bell.83fdd785.svg";